import { themeVar } from '@/styles/theme';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { IFilterBarData } from '@/components/basicComponents/filterBar';
import { IToggle } from '@/components/basicComponents/toggle';
import { useResponsive } from '../../../hooks/use-responsive';
import { TData } from '../../basicComponents/selectWithCheckBox';
import DesktopFilterPage from './desktop-filter';
import LandscapeFilterPage from './landscape-filter';
import PortraitFilterPage from './portrait-filter';
import { AdditionalFilters, IFilterDownloadButton, IQuickFilter } from './types';

// export enum DATA_TYPE {
//   COMPLIANCE = 'compliance',
//   DUE_DILIGENCE_RECORDS = 'dueDiligenceRecords',
//   COMMITMENTS = 'commitments',
//   RECOMMENDATIONS = 'recommendations'
// }

interface FilterPageProps {
  search?: {
    value: string;
    onChange: any;
    placeholder: string;
  };
  primaryFilter?: {
    value: string;
    onChange: (value: string) => void;
    selects: string[];
    withSearch?: boolean;
  };
  withCheckBox?: boolean;
  additionalFilters?: AdditionalFilters;
  setAllocationStatusFilter?: any;
  allocationStatusFilter?: TData[];
  currentTab?: { value: string };
  className?: string;
  withResult?: boolean;
  resultsValue?: number;
  isDealRegistryFilter?: boolean;
  refetch?: () => void;
  setIsMoreFiltersOpen?: Dispatch<SetStateAction<boolean>>;
  handleTableColumns?: () => void;
  viewBySelect?: {
    value: string;
    onChange: (value: string) => void;
    selects: string[];
  };
  filterBar?: IFilterBarData[];
  onChangeFilterBar?: (filterBarItems: IFilterBarData[]) => void;
  mobileSort?: {
    value: string;
    onChange: (value: string) => void;
    selects: string[];
  };
  useNewFilters?: boolean;
  advisoryFirmQuickFilter?: IQuickFilter;
  viewByQuickFilter?: IQuickFilter;
  quickFilter?: IQuickFilter;
  toggle?: IToggle;
  downloadButton?: IFilterDownloadButton;
}

const FilterPage = ({
  search,
  primaryFilter,
  additionalFilters,
  withCheckBox,
  setAllocationStatusFilter,
  allocationStatusFilter,
  currentTab,
  className,
  withResult = true,
  resultsValue,
  refetch,
  setIsMoreFiltersOpen,
  handleTableColumns,
  viewBySelect,
  isDealRegistryFilter = false,
  filterBar,
  onChangeFilterBar,
  mobileSort,
  useNewFilters = false,
  advisoryFirmQuickFilter,
  viewByQuickFilter,
  quickFilter,
  toggle,
  downloadButton
}: FilterPageProps) => {
  const { isPortrait, isMobile, isDesktop, isTablet, isLargeDesktop } = useResponsive();

  return (
    <FilterPageWrapper id="table-filters" isMobile={isMobile} isTablet={isTablet} className={className}>
      {isDesktop || isTablet || isLargeDesktop ? (
        <DesktopFilterPage
          search={search}
          primaryFilter={primaryFilter}
          isResult={withResult}
          additionalFilters={additionalFilters}
          withCheckBox
          currentTab={currentTab}
          allocationStatusFilter={allocationStatusFilter}
          setAllocationStatusFilter={setAllocationStatusFilter}
          resultsValue={resultsValue}
          refetch={refetch}
          handleTableColumns={handleTableColumns}
          viewBySelect={viewBySelect}
          isDealRegistryFilter={isDealRegistryFilter}
          filterBar={filterBar}
          onChangeFilterBar={onChangeFilterBar}
          useNewFilters={useNewFilters}
          advisoryFirmQuickFilter={advisoryFirmQuickFilter}
          viewByQuickFilter={viewByQuickFilter}
          quickFilter={quickFilter}
          toggle={toggle}
          downloadButton={downloadButton}
        />
      ) : (
        ((useNewFilters || (isPortrait && isMobile)) && (
          <PortraitFilterPage
            search={search}
            primaryFilter={primaryFilter}
            isResult={withResult}
            additionalFilters={additionalFilters}
            withCheckBox
            currentTab={currentTab}
            allocationStatusFilter={allocationStatusFilter}
            setAllocationStatusFilter={setAllocationStatusFilter}
            resultsValue={resultsValue}
            refetch={refetch}
            setIsMoreFiltersOpen={setIsMoreFiltersOpen}
            handleTableColumns={handleTableColumns}
            filterBar={filterBar}
            onChangeFilterBar={onChangeFilterBar}
            mobileSort={mobileSort}
            viewBySelect={viewBySelect}
            useNewFilters={useNewFilters}
            advisoryFirmQuickFilter={advisoryFirmQuickFilter}
            viewByQuickFilter={viewByQuickFilter}
            quickFilter={quickFilter}
            toggle={toggle}
            downloadButton={downloadButton}
          />
        )) ||
        (!isPortrait && isMobile && (
          <LandscapeFilterPage
            search={search}
            primaryFilter={primaryFilter}
            additionalFilters={additionalFilters}
            withCheckBox
            currentTab={currentTab}
            allocationStatusFilter={allocationStatusFilter}
            setAllocationStatusFilter={setAllocationStatusFilter}
            resultsValue={resultsValue}
            refetch={refetch}
            handleTableColumns={handleTableColumns}
            filterBar={filterBar}
            onChangeFilterBar={onChangeFilterBar}
            mobileSort={mobileSort}
            viewBySelect={viewBySelect}
            downloadButton={downloadButton}
          />
        ))
      )}
    </FilterPageWrapper>
  );
};

export default FilterPage;

const FilterPageWrapper = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  position: sticky;
  top: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '50px' : '0')};
  z-index: 9;
  padding: ${({ isMobile }) => (isMobile ? '20px 0 0 0' : '20px 0 10px 0')};
  background-color: ${themeVar('layer.base')};
`;
